module.exports = __webpack_public_path__ + "img/flyer-icon-7.b01158e2.svg";